import { gql } from '@apollo/client'
import {
  PreflightBatch,
  PreflightBatchVariables,
  PreflightBatch_preflightBatch
} from 'src/smart/mutations/types/PreflightBatch'
import { SmartMutation } from 'src/smart/SmartMutation'

export const SM_PREFLIGHT_BATCH: SmartMutation<
  PreflightBatchVariables,
  PreflightBatch,
  PreflightBatch_preflightBatch
> = {
  mutation: gql`
    mutation PreflightBatch($batchId: String!, $locale: String) {
      preflightBatch(batchId: $batchId, locale: $locale) {
        batchId
        status
        teamId
        teamName
        uploadId
        workbookId
        workspaceId
        schemas {
          id
          jsonSchema {
            schema
          }
        }
        synced
        features
        config {
          devMode
          helpContent
          theme {
            id
            name
            attributes {
              type
              name
              hex
            }
            colors {
              name
              hex
            }
            font {
              typeKitId
              fontFamily
            }
          }
        }
        paymentExpired
        locale
      }
    }
  `,
  extract: ({ preflightBatch }) => preflightBatch
}
